import { useApp } from "@/context/AppContext";

export default function Marquee() {
  const { t } = useApp();
  const words = t.marquee;
  const row = [...words, ...words, ...words, ...words];
  return (
    <div className="bg-slate-50 border-y border-slate-200 overflow-hidden py-6" data-testid="marquee">
      <div className="marquee-track">
        {row.map((w, i) => (
          <span key={i} className="font-display font-bold text-2xl md:text-4xl uppercase tracking-tight text-slate-800 mx-8 flex items-center gap-16">
            {w}
            <span className="w-2.5 h-2.5 bg-accent2 inline-block" />
          </span>
        ))}
      </div>
    </div>
  );
}
